const arrayDeepClone = (items) =>
  items.map((item) => (Array.isArray(item) ? arrayDeepClone(item) : item))

export default arrayDeepClone
